import config from '../config';

export default {
    data: function () {
        return {
            apiUrl: config.apiUrl 
        };
    }
};